export default __webpack_public_path__ + "static/media/reporthelp-form.dfb66cba.PNG";